export default __webpack_public_path__ + "static/workflowAutomationHero-19ca81cd14adeebf607b2cf1ddbe5af2.webp";